import { ElementType, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { useTrackEvent } from 'tracking/useTrackEvent';
import { useAvroTracking } from './avro';

export function withScrollTracking<T>(Component: ElementType<T>) {
  return function Tracking({
    avroIdentifier,
    preAvroIdentifier,
    ...rest
  }: T & {
    avroIdentifier: string;
    preAvroIdentifier: string;
  }) {
    const trackEvent = useTrackEvent();
    const { emitInViewEvent } = useAvroTracking();
    const [ref, inView] = useInView();

    useEffect(() => {
      if (inView) {
        trackEvent('component_scrolled_into_view', {
          component: preAvroIdentifier,
        });
        emitInViewEvent({
          custom_tracking_fields: {
            component: avroIdentifier,
          },
        });
      }
    }, [
      avroIdentifier,
      emitInViewEvent,
      inView,
      preAvroIdentifier,
      trackEvent,
    ]);

    return (
      //@ts-ignore
      <Component ref={ref} {...rest} />
    );
  };
}
